import { PLATFORM_LOAD_HANG_QUERY_VALUE } from '@utils/platformLoadHang';

import clock from '@plugins/dayjs';

import config from '@/config';

function mapPendingRequest(request) {
    const requestAt = request.request_at;
    const elapsedMs = requestAt ? clock().diff(clock(requestAt), 'milliseconds') : null;

    return {
        method: request.method,
        url: request.url,
        request_at: requestAt,
        elapsedMs
    };
}

export function buildPlatformLoadDiagnostics({ store, auth, route, elapsedMs = null, simulateHang = false }) {
    const pendingRequests = (store?.state?.requests?.requests || [])
        .filter(request => request.status === 'pending')
        .map(mapPendingRequest);

    return {
        elapsedMs,
        route: {
            name: route?.name || null,
            path: route?.path || null,
            fullPath: route?.fullPath || null
        },
        auth: {
            has_user: !!auth?.has_user,
            is_initialised: !!auth?.is_initialised,
            has_branding: !!auth?.has_branding,
            onboarding: !!auth?.onboarding
        },
        routing: !!store?.getters?.['app/routing'],
        pendingRequests,
        simulateHang: !!simulateHang,
        environment: {
            hostname: typeof window !== 'undefined' ? window.location.hostname : null,
            userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : null,
            appEnv: config.APP_ENV || null
        }
    };
}

export function formatPlatformLoadDiagnostics(diagnostics = {}) {
    const lines = [];

    if (diagnostics.elapsedMs !== null && diagnostics.elapsedMs !== undefined) {
        lines.push(`Elapsed: ${diagnostics.elapsedMs}ms`);
    }

    if (diagnostics.route) {
        lines.push(`Route: ${diagnostics.route.fullPath || diagnostics.route.path || 'unknown'}`);
        if (diagnostics.route.name) {
            lines.push(`Route name: ${diagnostics.route.name}`);
        }
    }

    if (diagnostics.auth) {
        const { has_user, is_initialised, has_branding, onboarding } = diagnostics.auth;
        lines.push(
            `Auth: has_user=${has_user}, is_initialised=${is_initialised}, ` +
                `has_branding=${has_branding}, onboarding=${onboarding}`
        );
    }

    lines.push(`Routing in progress: ${diagnostics.routing}`);

    if (diagnostics.simulateHang) {
        lines.push(`Simulated hang: yes (?hang=${PLATFORM_LOAD_HANG_QUERY_VALUE})`);
    }

    if (diagnostics.pendingRequests?.length) {
        lines.push('Pending requests:');
        diagnostics.pendingRequests.forEach((request, index) => {
            const { method, url, request_at, elapsedMs } = request;
            lines.push(`  ${index + 1}. ${method} ${url} (started ${request_at}, elapsed ${elapsedMs}ms)`);
        });
    } else {
        lines.push('Pending requests: none');
    }

    if (diagnostics.environment) {
        lines.push(`Hostname: ${diagnostics.environment.hostname}`);
        lines.push(`App environment: ${diagnostics.environment.appEnv}`);
        if (diagnostics.environment.userAgent) {
            lines.push(`User agent: ${diagnostics.environment.userAgent}`);
        }
    }

    return lines.join('\n');
}
